import React, { useMemo } from 'react'
import { useGlobalState } from 'src/context/global'
import { Modal } from 'src/refactor/blocks'
import styled, { css } from 'styled-components'
import ReactVideoPlayer from 'react-player'
import { useMediaContext } from 'src/context/responsive'
import ReactModal from 'react-modal'
import { Icon } from '@centivo/react-components'

const VideoPlayerContent = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 90%;

  div.close-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 90vw;
    max-width: 40rem;

    button {
      color: white;
      font-size: 1.5rem;
      padding: 0.5rem;
      padding-right: 0;
    }

    ${({ isMobile }) =>
      isMobile
        ? css`
            width: 100%;

            button {
              padding-right: 0.5rem;
            }
          `
        : ''}
  }
`

export const VideoPlayer: React.FC<{
  isOpen: boolean
  setIsOpen: (open: boolean) => void
}> = ({ isOpen, setIsOpen }) => {
  const { isMobileView } = useMediaContext()
  const [{ appConfig }] = useGlobalState()
  const {
    video: { url: videoUrl },
  } = appConfig

  const closeModal = () => setIsOpen(false)

  const modalConfig: ReactModal.Styles = useMemo(
    () => ({
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      },
      content: {
        height: '100vh',
        padding: '0',
        inset: '0',
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
        ...(isMobileView
          ? {
              width: '100%',
            }
          : {
              width: '640px',
            }),
      },
    }),
    [isMobileView]
  )

  return (
    <Modal
      style={modalConfig}
      isOpen={isOpen}
      onRequestClose={closeModal}
      shouldCloseOnOverlayClick
    >
      <VideoPlayerContent isMobile={isMobileView}>
        <div className="close-container" onClick={closeModal}>
          <Icon icon="x" onClick={closeModal} />
        </div>
        <ReactVideoPlayer
          url={videoUrl}
          width="100%"
          height="min(54.58vw, 22.5rem)"
          playing
          controls
        />
      </VideoPlayerContent>
    </Modal>
  )
}
